export default "__VITE_ASSET__tiXi6vmo__"